import { defineComponent as _defineComponent } from 'vue'
import { inject } from "vue";
import { TimeDataKey } from "./time-data";
import type { TimeData } from "./time-data";


export default /*#__PURE__*/_defineComponent({
  __name: 'background-image',
  setup(__props, { expose }) {
  expose();

const { darkMode } = inject(TimeDataKey) as TimeData;

const __returned__ = { darkMode, inject, TimeDataKey }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})